import { appSwitchRoutes } from 'constants/routes';
import { ModalTypes } from 'enums/modalTypes';
import { Maybe, useStageCandidateFindOneQuery } from 'generated/graphql';
import { closeModal } from 'graphql/modals';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import CandidateInformationFormContainer from './CandidateInformationFormContainer/CandidateInformationFormContainer';

interface ICandidateInformationContainer {
  stageCandidateId: number;
  /** Company logo shown in the form header; hosts pass it from myRole data. */
  companyLogoUrl?: Maybe<string>;
  onCandidateInformationProvided?: () => void;
  onCandidateInformationFormPreviouslyCompleted?: () => void;
}

const CandidateInformationContainer: FC<ICandidateInformationContainer> = ({
  stageCandidateId,
  companyLogoUrl,
  onCandidateInformationProvided,
  onCandidateInformationFormPreviouslyCompleted,
}) => {
  const navigate = useNavigate();
  const { handleMsgType } = useNotification();

  const stageCandidateQueryResponse = useStageCandidateFindOneQuery({
    variables: {
      id: stageCandidateId,
    },
    onError: error => {
      handleMsgType({
        type: TNotification.error,
        message: error?.message,
      });

      closeModal(ModalTypes.CANDIDATE_INFORMATION);
      navigate(appSwitchRoutes.roles.getUrl());
    },
  });

  const stageCandidate =
    stageCandidateQueryResponse.data?.StageCandidateFindById;
  const companyId = stageCandidate?.companyId;
  const projectId = stageCandidate?.stage.projectId;

  if (companyId && projectId) {
    return (
      <CandidateInformationFormContainer
        stageProjectCompanyId={companyId}
        stageProjectCompanyLogoUrl={companyLogoUrl}
        projectId={projectId}
        onCandidateInformationProvided={onCandidateInformationProvided}
        onCandidateInformationFormPreviouslyCompleted={
          onCandidateInformationFormPreviouslyCompleted
        }
      />
    );
  }

  return null;
};

export default CandidateInformationContainer;
